import { defineStore } from 'pinia';
import { AppConfigType, LimitDataType, SystemDataType } from 'types/appConfig';
import { IWebSocketService } from 'types/socket';

interface IMyBet {
    account?: number;
    billNo?: string;
    content?: string;
    createTime?: string;
    gameName?: string;
    odds?: number;
    payment?: number;
    result?: number;
    status?: number;
    username?: string;
    sn?: string;
}

interface SocketState {
    ws: IWebSocketService | null;
    resultList: any[]; // 开奖结果
    luckyList: any[]; // 中奖结果
    betList: any[]; // 投注
    myBetList: IMyBet[]; // 我的投注
    onlineBetList: any[]; // 在线投注
    historyList: any[]; // 历史投注
    // 所有连接成功的socket
    socketList: IWebSocketService[];
}

export const useSocketStore = defineStore('socketStore', {
    state: (): SocketState => ({
        ws: null,
        resultList: [], // 开奖结果
        luckyList: [], // 中奖结果
        betList: [], // 投注
        myBetList: [], // 我的投注
        onlineBetList: [], // 在线投注
        historyList: [], // 历史投注
        socketList: [], // 所有连接成功的socket
    }),
    getters: {
        getResultList: (state: SocketState) => state.resultList, // 获取开奖结果
        getLuckyList: (state: SocketState) => state.luckyList, // 获取中奖结果
        getBetList: (state: SocketState) => state.betList, // 获取投注
        getMyBetList: (state: SocketState) => state.myBetList, // 获取我的投注
        getOnlineBetList: (state: SocketState) => state.onlineBetList, // 获取在线投注
        getHistoryList: (state: SocketState) => state.historyList, // 获取历史投注
        getWebSocket: (state: SocketState) => state.ws, // 获取WebSocket
    },
    actions: {
        setSocketList(data: IWebSocketService) {
            this.socketList.push(data);
        },
        clearSocketList() {
            this.socketList = [];
        },
        // 设置开奖结果
        setResultList(data: any) {
            if (this.resultList.length > 50) {
                this.resultList.pop();
            }
            this.resultList.unshift(data);
        },

        // 设置中奖结果
        setLuckyList(data: any) {
            if (this.luckyList.length > 50) {
                this.luckyList.pop();
            }
            this.luckyList.unshift(data);
        },

        // 设置投注
        setBetList(data: any) {
            if (this.betList.length > 50) {
                this.betList.pop();
            }
            this.betList.unshift(data);
        },

        // 设置我的投注
        setMyBetList(data: any) {
            // this.myBetList = data;
            if (this.myBetList.length > 50) {
                this.myBetList.splice(50, this.myBetList.length - 50);
            }
            this.myBetList.unshift(data);
        },

        // 设置在线投注
        setOnlineBetList(data: any) {
            if (this.onlineBetList.length > 50) {
                this.onlineBetList.splice(50, this.onlineBetList.length - 50);
            }
            this.onlineBetList.unshift(...data);
        },

        // 设置历史投注
        setHistoryList(data: any) {
            if (this.historyList && this.historyList.length > 50) {
                this.historyList.splice(50, this.historyList.length - 50);
            }
            this.historyList?.unshift(data);
        },
        setHistoryListPush(data: any) {
            if (this.historyList && this.historyList.length > 50) {
                this.historyList.splice(50, this.historyList.length - 50);
            }
            this.historyList?.push(data);
        },

        // 设置WebSocket
        setWebSocket(data: any) {
            this.ws = data;
        },

        // 清空开奖结果
        clearResultList() {
            this.resultList = [];
        },

        // 清空中奖结果
        clearLuckyList() {
            this.luckyList = [];
        },

        // 清空投注
        clearBetList() {
            this.betList = [];
        },

        // 清空我的投注
        clearMyBetList() {
            this.myBetList = [];
        },

        // 清空在线投注
        clearOnlineBetList() {
            this.onlineBetList = [];
        },

        // 清空历史投注
        clearHistoryList() {
            this.historyList = [];
        },

        // 清空所有
        clearAll() {
            this.resultList = [];
            this.luckyList = [];
            this.betList = [];
            this.myBetList = [];
            this.onlineBetList = [];
            this.historyList = [];
        },
    },
});
